import React from 'react';

import McCainLogo from 'assets/integrations/McCainLogo.png';
import SubmissionHistory from 'screens/Integrations/SubmissionHistory';
import { INTEGRATIONS } from 'screens/Integrations/helpers/constants';
import Provider from 'screens/Integrations/SubmissionHistory/context/Provider';
import LandingPage from 'screens/Integrations/components/LandingPage';
import Instructions from 'screens/Integrations/components/Instructions';

export const MCCAIN_STEPS = [
  {
    number: 1,
    header: 'Authenticate',
    description: 'Provide your McCain vendor ID to start a new submission'
  },
  {
    number: 2,
    header: 'Select Crop Seasons',
    description:
      'Select the Crop Seasons with which you would like to submit Application records'
  },
  {
    number: 3,
    header: 'Select Properties',
    description:
      'Select the Properties with Application records you would like to submit'
  },
  {
    number: 4,
    header: 'Review and Submit',
    description:
      'Review your Application records and then submit the information to McCain Foods Inc.'
  }
];

const MccainLandingPage = () => {
  return (
    <>
      <LandingPage
        headerText={`${INTEGRATIONS.mccain} Foods Inc. Integration`}
        breadcrumbText={INTEGRATIONS.mccain}
        ownerText={INTEGRATIONS.mccain}
        targetPath={INTEGRATIONS.mccain}
        LogoImg={McCainLogo}
        imgStyle={{ height: '48px', width: 'auto' }}
      />
      <div className="w-full border-t-1 mb-5" />
      <Provider integrationType={INTEGRATIONS.mccain}>
        <SubmissionHistory />
      </Provider>
      <Instructions steps={MCCAIN_STEPS} />
    </>
  );
};

export default MccainLandingPage;
